import { useQueryClient } from '@tanstack/react-query';
import { FILTERS_KEY, defaultFiltersState } from '../constants';
export default function useUpdateFilters() {
    const queryClient = useQueryClient();
    const updateFilters = (partial) => {
        queryClient.setQueryData(FILTERS_KEY, (prev = defaultFiltersState) => (Object.assign(Object.assign({}, prev), partial)));
    };
    return updateFilters;
}
